export default "__VITE_ASSET__Cp6h3p7g__"